<template lang="pug">
  form(@submit.prevent="onSubmit")
    .form-group(v-if="isSuccess || Object.keys(errors).length")
        .alert(:class="isSuccess ? 'alert-success' : 'error_explanation'")
          div(v-if="isSuccess") {{ successMessage }}
          form-error(:errors="errors" v-else="")

    div.row
      div.col-12(v-if="subjects.length > 0" class="mb-4 lg:mb-8")
        multiselect(v-model="contact.subject" class="multiselect-default" :searchable="false" :options="subjects" :show-labels="false" :placeholder="defaultSubject")

      div.col-12(class="lg:col-6 mb-4 lg:mb-8")
        input#contact_lastname.form-control(v-model="contact.lastname" type="text" required="required" placeholder="Nom" :class="{'field_with_errors': errors.lastname}")

      div.col-12(class="lg:col-6 mb-4 lg:mb-8")
        input#contact_firstname.form-control(v-model="contact.firstname" type="text" required="required" placeholder="Prénom" :class="{'field_with_errors': errors.firstname}")

      div.col-12(class="lg:col-6 mb-4 lg:mb-8")
        input#contact_phone.form-control(v-model="contact.phone" type="phone" placeholder="Téléphone" :class="{'field_with_errors': errors.base}")

      div.col-12(class="lg:col-6 mb-4 lg:mb-8")
        input#contact_email.form-control(v-model="contact.email" type="email" required="required" placeholder="E-mail" :class="{'field_with_errors': errors.base}")

      div.col-12(class="mb-4 lg:mb-8")
        textarea#contact_message.form-control(v-model="contact.message" type="textarea" rows="7" placeholder="Message" :class="{'field_with_errors': errors.message}")

      div.col-12(class="mb-4 lg:mb-8")
        p-check(v-model="contact.rgpd_terms_accepted" class="p-default" required="required")
        | En soumettant ce formulaire, j’accepte que les informations saisies dans ce formulaire soient utilisées, exploitées, traitées pour permettre de me recontacter. Découvrez comment nous recueillons, utilisons et partageons vos données en lisant notre Politique d’utilisation des données.
      div.col-12
        div(class="flex flex-col lg:flex-row justify-between items-start")
          p(class="text-secondary text-12 lg:w-4/5 leading-16 mb-6 lg:mb-0")
            span Vos informations sont traitées par Immobiliere Dabreteau et transmises au professionnel de l’immobilier que vous souhaitez contacter afin de gérer votre demande. Pour exercer vos droits conformément à la loi «informatique et libertés »,
            a.text-secondary(:href="mentionLegalesUrl") Cliquez ici
          div(class="flex justify-center lg:justify-end w-full lg:w-1/5 text-center")
            vue-recaptcha(
                ref="recaptcha"
                size="invisible"
                :sitekey="recaptchaAppKey"
                @verify="onCaptchaVerify"
                @expired="onCaptchaExpired")
            div.btn.btn-secondary(class="p-0")
              input(type="submit" value="Envoyer" class="relative bg-transparent text-white font-bold px-8 py-5 outline-none z-20")
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'
import FormError from './FormError'

export default {
  components: {
    VueRecaptcha,
    FormError
  },
  props: {
    recaptchaAppKey: {
      type: String,
      required: true
    },
    subjects: {
      type: Array,
      default () { return [] }
    },
    redirectOnSubmit: {
      type: String,
      default: ''
    },
    successMessage: {
      type: String,
      default: 'Le message a bien été envoyé'
    },
    contactable: {
      type: Object,
      default () { return {} }
    },
    mentionLegalesUrl: {
      type: String,
      required: true
    },
    defaultSubject: {
      type: String,
      default () {
        return this.subjects.length > 0 ? this.subjects[0] : undefined
      }
    }
  },

  data () {
    return {
      contact: {
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        message: '',
        subject: this.defaultSubject,
        contactable_type: this.contactable.data.type,
        contactable_id: this.contactable.data.id,
        rgpd_terms_accepted: this.rgpd_terms_accepted
      },
      errors: [],
      isSuccess: false,
      isSubmitting: false
    }
  },

  created () {
    this.$event.$on('scroll-to-contact-form', (payload) => {
      this.contact.subject = payload.subject
    })
  },

  methods: {
    onSubmit () {
      this.$refs.recaptcha.execute()
    },

    onCaptchaVerify (recaptchaToken) {
      this.isSubmitting = true
      this.isSuccess = false
      this.$refs.recaptcha.reset()

      this.errors = []

      axios.post('/api/v1/contacts', {
        contact: this.contact,
        'g-recaptcha-response': recaptchaToken
      })
        .then((response) => {
          if (this.redirectOnSubmit) {
            window.location.href = this.redirectOnSubmit
          } else {
            this.isSuccess = true

            this.resetForm()
          }
        })
        .catch(({ response: { data } }) => {
          this.isSubmitting = false
          this.errors = data.errors.data.attributes.errors
        })
        .then(() => {
          this.isSubmitting = false
        })
    },

    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },

    resetForm () {
      this.contact = {
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        message: '',
        subject: this.defaultSubject,
        contactable_type: this.contactable.type,
        contactable_id: this.contactable.id
      }

      this.errors = {}
    }
  }
}
</script>
